module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "md6": "",
      "offset-md3": "",
      "offset-sm1": ""
    }
  }, [(1 == 2) ? _c('cliente-factura') : (_vm.hasfactura) ? _c('v-card', {
    staticClass: "factura"
  }, [_c('v-card-title', {
    staticClass: "primary"
  }, [_c('div', {
    staticClass: "encabezado",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "margin": "0",
      "width": "100%"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('b1', {
    staticClass: "white--text",
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "name": "cliente"
    }
  }, [_vm._v(" Cliente Anular: " + _vm._s(_vm.cliente.nombre))])], 1), _vm._v(" "), (_vm.cliente.nit) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('b1', {
    staticClass: "white--text",
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "name": "nit"
    }
  }, [_vm._v("Nit: " + _vm._s(_vm.cliente.nit))])], 1) : _vm._e(), _vm._v(" "), (!_vm.cliente.nit) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('b1', {
    staticClass: "white--text",
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "name": "nit"
    }
  }, [_vm._v("Nit: " + _vm._s(_vm.cliente.codigo))])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "factura__direccion",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "margin": "0",
      "width": "100%"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('b1', {
    staticClass: "white--text",
    staticStyle: {
      "padding": "0"
    }
  }, [_vm._v("Direccion: " + _vm._s(_vm.cliente.direccion))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "factura__date"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('b1', {
    staticClass: "white--text",
    staticStyle: {
      "padding": "0"
    }
  }, [_vm._v(" Fecha: " + _vm._s(_vm.fecha))])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('b1', {
    staticClass: "white--text",
    staticStyle: {
      "padding": "0"
    }
  }, [_vm._v(" Hora: " + _vm._s(_vm.hora))])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.factura.credito) ? _c('b1', {
    staticClass: "white--text",
    staticStyle: {
      "padding": "0"
    }
  }, [_vm._v("CREDITO")]) : _vm._e(), _vm._v(" "), (!_vm.factura.credito) ? _c('b1', {
    staticClass: "white--text",
    staticStyle: {
      "padding": "0"
    }
  }, [_vm._v("CONTADO")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0 ma-0 credito",
    attrs: {
      "sm5": "",
      "xs6": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Anular Factura",
      "dark": "",
      "disabled": _vm.factura.rechazado
    },
    on: {
      "change": _vm.anularfactura
    },
    model: {
      value: (_vm.factura.anulado),
      callback: function($$v) {
        _vm.$set(_vm.factura, "anulado", $$v)
      },
      expression: "factura.anulado"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0 ma-0 total",
    attrs: {
      "xs6": ""
    }
  }, [_c('h5', {
    staticClass: "white--text"
  }, [_vm._v("Total: Q." + _vm._s(_vm.total))])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm12": ""
    }
  }, [(_vm.error) ? _c('v-alert', {
    attrs: {
      "error": "",
      "value": "false"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.message_error) + "\n          ")]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasfactura),
      expression: "hasfactura"
    }],
    staticClass: "factura__detalle"
  }, [_c('v-flex', {
    staticClass: "tabla",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table text-md-center"
  }, [_c('tr', [_c('th'), _vm._v(" "), _vm._l((_vm.headers), function(header) {
    return _c('th', [_vm._v(" " + _vm._s(header.text))])
  })], 2), _vm._v(" "), _c('tbody', [_vm._l((_vm.lineas), function(linea) {
    return _c('tr', [_c('td', [_c('v-btn', {
      staticClass: "blue--text text--darken-2",
      attrs: {
        "icon": "",
        "disabled": _vm.grabando,
        "loading": _vm.grabando
      },
      on: {
        "click": function($event) {
          return _vm.eliminar(linea)
        }
      }
    }, [_c('v-icon', [_vm._v("cancel")])], 1)], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(linea.cantidad))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(linea.presentacion))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(linea.producto_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(linea.precio))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("currency")(linea.precio * linea.cantidad, 'Q')))])])
  }), _vm._v(" "), _c('tr', {
    staticClass: "factura__detalle__total"
  }, [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("Total")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.total))])])], 2)])])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "persistent": ""
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Motivo de Anulación")])]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "comentario",
      "multi-line": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.actualizarnota($event)
      }
    },
    model: {
      value: (_vm.motivonota),
      callback: function($$v) {
        _vm.motivonota = $$v
      },
      expression: "motivonota"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.actualizarnota($event)
      }
    }
  }, [_vm._v("Aceptar")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "persistent": ""
    },
    model: {
      value: (_vm.dialogbusqueda),
      callback: function($$v) {
        _vm.dialogbusqueda = $$v
      },
      expression: "dialogbusqueda"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Buscar Producto")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm12": ""
    }
  }, [_c('v-text-field', {
    ref: "searchprodi",
    attrs: {
      "label": "Nombre",
      "autofocus": ""
    },
    on: {
      "keyup": _vm.searchproductos
    },
    model: {
      value: (_vm.nombreproducto),
      callback: function($$v) {
        _vm.nombreproducto = $$v
      },
      expression: "nombreproducto"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('ul', {
    staticClass: "listadoproducto"
  }, _vm._l((this.productos), function(product, key) {
    return _c('li', {
      attrs: {
        "tabindex": 0
      },
      on: {
        "click": function($event) {
          _vm.searchproductodialog(product), _vm.dialogbusqueda = false, _vm.nombreproducto = ''
        },
        "keyup": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          _vm.searchproductodialog(product), _vm.dialogbusqueda = false, _vm.nombreproducto = ''
        }
      }
    }, [_vm._v("\n             " + _vm._s(product.producto) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "tabindex": -1,
      "flat": "flat"
    },
    on: {
      "click": _vm.resetbusqueda
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogbusqueda = false
      }
    }
  }, [_vm._v("Cancelar")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "persistent": ""
    },
    model: {
      value: (_vm.message),
      callback: function($$v) {
        _vm.message = $$v
      },
      expression: "message"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Motivo de Anulación")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "comentario",
      "multi-line": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.anularfactura($event)
      }
    },
    model: {
      value: (_vm.factura.motivo_anulacion),
      callback: function($$v) {
        _vm.$set(_vm.factura, "motivo_anulacion", $$v)
      },
      expression: "factura.motivo_anulacion"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-text'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "tabindex": -1,
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.message = false, _vm.factura.anulado = false
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    on: {
      "click": _vm.anularfactura
    },
    nativeOn: {
      "click": function($event) {
        _vm.message = false
      }
    }
  }, [_vm._v("Guardar")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "persistent": ""
    },
    model: {
      value: (_vm.messagemotivo),
      callback: function($$v) {
        _vm.messagemotivo = $$v
      },
      expression: "messagemotivo"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Motivo por el que no compro")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm12": ""
    }
  }, [_c('div', {
    staticClass: "select"
  }, [_c('label', {
    attrs: {
      "for": "motivo"
    }
  }, [_vm._v("Motivo:  ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.factura.observacionesmotivo),
      expression: "factura.observacionesmotivo"
    }],
    attrs: {
      "id": "motivo"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.factura, "observacionesmotivo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.cambiarcomentariomotivo]
    }
  }, _vm._l((_vm.motivos), function(motivo) {
    return _c('option', {
      domProps: {
        "value": motivo
      }
    }, [_vm._v("\n                " + _vm._s(motivo) + "\n              ")])
  }), 0)])])], 1), _vm._v(" "), _c('v-card-text'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "tabindex": -1,
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.messagemotivo = false
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    on: {
      "click": _vm.anularfactura
    },
    nativeOn: {
      "click": function($event) {
        _vm.messagemotivo = false
      }
    }
  }, [_vm._v("Guardar")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "enletras",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', [_vm._v("TOTAL EN LETRAS: " + _vm._s(_vm.numerosaletras))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "firmas"
  }, [_c('v-flex', {
    attrs: {
      "sm6": ""
    }
  }, [_vm._v("Vendedor: " + _vm._s(_vm.factura.usuario.username))]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": ""
    }
  }, [_vm._v("Cliente")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c12f544"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AnularFactura.vue
// module id = 432
// module chunks = 1